import React, { forwardRef } from 'react'
import * as LucideIcons from 'lucide-react'

const Input = forwardRef(({
  label,
  error,
  icon,
  helpText,
  className = '',
  containerClassName = '',
  ...props
}, ref) => {
  const IconComponent = icon ? LucideIcons[icon] : null

  // Check if field is empty/incomplete (only for required fields or if value is provided)
  const isEmpty = props.value !== undefined && (!props.value || props.value.toString().trim() === '')
  const showIncompleteStyle = isEmpty && (props.required || label?.includes('*'))

  return (
    <div className={`w-full ${containerClassName}`}>
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {IconComponent && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <IconComponent className="w-5 h-5 text-slate-400" />
          </div>
        )}
        <input
          ref={ref}
          className={`
            w-full px-4 py-3
            ${IconComponent ? 'pl-10' : ''}
            border-2 rounded-lg
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : showIncompleteStyle ? 'border-orange-500 focus:ring-orange-500 focus:border-orange-500' : 'border-slate-300 focus:ring-primary-500 focus:border-primary-500'}
            focus:outline-none focus:ring-2
            transition-colors duration-200
            placeholder:text-slate-400
            disabled:bg-slate-100 disabled:cursor-not-allowed
            ${className}
          `}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-red-600">{error}</p>
      )}
      {helpText && !error && (
        <p className="mt-1.5 text-sm text-slate-500">{helpText}</p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input
